import React, { Fragment } from 'react';
import CopyRightSection from './CopyRightSection.SA'
import ContactUs from './ContactUs.SA';
import ixion from "../../images/ImagesSA/BannerFooter/ixion.png";

const Footer: React.FC = () => {
  return (
    <Fragment>
        <ContactUs/>
        <CopyRightSection content="Salud SA Todos los derechos reservados" image= {<img src={ixion} className="img-fluid" alt="Imagen más" />} />  
    </Fragment>
  );
};

export default Footer;